'use client';

import { sendTrendingSuperstarLoadEvent } from '@wwe-portal/web/libs/analytics/superstars-v2';
import { useEffect } from 'react';
import { useSearchFilter } from './use-search-filter';

export const SuperstarHomeLoadAnalytics = () => {
  const { playStyle, era, classValue, owned } = useSearchFilter();
  useEffect(() => {
    sendTrendingSuperstarLoadEvent({ playStyle, era, classValue, owned });
  }, [playStyle, era, classValue, owned]);
  return null;
};
